import React, {Component} from 'react';
import axios from 'axios';
import {FaBell} from "react-icons/fa";
import { Card, CardBody } from 'reactstrap';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import BreadcrumbCustomer from "../../Layout/user/BreadcrumbCustomer";

class CreateTicketComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: false,
            btnSubmit: false,
            title: '',
            content: '',
            errorForm: false,
            messageErrorForm: ''
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    changeInput = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        this.setState({
            [name]: value
        })
    }

    submit = () => {
        if ( this.validate() ) {
            this.setState({
                loadPage: true,
                btnSubmit: true,
            })

            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };
            let form = {
                title: this.state.title,
                content: this.state.content,
            };
            axios.post( process.env.REACT_APP_API_URL + '/api/ticket/createTicket', form,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization' : this.props.token,
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    // console.log(ref.data);
                    if (ref.data.error === 0) {
                        this.redirect(ref.data.message);
                    } else {
                        if (ref.data.error > 9000) {
                            this.props.logOut();
                        } else {
                            this.setState({
                                loadPage: false,
                                btnSubmit: false,
                                errorForm: true,
                                messageErrorForm: ref.data.message,
                            })
                        }
                    }
                    // console.log(this.state.perPage);
                })
                .catch( (error) => {
                    console.log(error);
                    this.setState({
                        btnSubmit: false,
                        loadPage: false,
                        errorForm: true,
                        messageErrorForm: 'Tạo hổ trợ thất bại',
                    })
                })
        }
    }

    redirect = (message) => {
        this.props.updateSuccessNotiUser({
            success: true,
            message: message
        });
        this.props.shouldRedirect();
    }

    validate = () => {
        if ( this.state.title.length < 5 && this.state.title.length > 50 ) {
            this.setState({
                errorForm: true,
                messageErrorForm: 'Số ký tự của "Vấn đề bạn cần hỗ trợ?" không được nhỏ hơn 5 ký tự hoặc lớn hơn 50 ký tự',
            })
            return false;
        }
        else if ( !this.state.content.length ) {
            this.setState({
                errorForm: true,
                messageErrorForm: 'Miêu tả chi tiết vấn đề không được để trống',
            })
            return false;
        }
        return true;
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <BreadcrumbCustomer title={"Yêu cầu hỗ trợ"} page={"Hỗ trợ"} icon={<FaBell className="breadcrumb-icon"/>}/>
                            <Card>
                                <CardBody>
                                    <div className="col-md-12">
                                        {
                                            this.state.errorForm ? (
                                                <>
                                                    <Alert color="danger">
                                                        { this.state.messageErrorForm }
                                                    </Alert>
                                                </>
                                            ) : (
                                                <></>
                                            )
                                        }
                                    </div>
                                    <div className="form-group">
                                        <label>Vấn đề bạn cần hỗ trợ?</label>
                                        <input type="text" name="title"  className="form-control"
                                               value={this.state.title} onChange={ this.changeInput } />
                                    </div>
                                    <div className="form-group">
                                        <label>Miêu tả chi tiết vấn đề</label>
                                        <textarea name="content" className="form-control"
                                                  rows="5" onChange={ this.changeInput }
                                                  defaultValue={this.state.content}
                                        />
                                    </div>
                                    <button type="button" className="btn btn-success btn-sm"
                                            onClick={ () => this.submit() }
                                            disabled={ this.state.btnSubmit }
                                    >
                                        Gửi hỗ trợ
                                    </button>
                                </CardBody>
                            </Card>
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        user: state.user.user,
        credit: state.user.credit,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
        errorNotificationUser: state.notificationUser.errorNotificationUser,
        messageErrorNotificationUser: state.notificationUser.messageErrorNotificationUser,
        successNotificationUser: state.notificationUser.successNotificationUser,
        messageSuccessNotificationUser: state.notificationUser.messageSuccessNotificationUser,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'CustomerTicket' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
        updateCredit: (item) => {
            dispatch(({ type : 'updateCredit', item }))
        },
        updateUrlRedirect: (item) => {
            dispatch(({ type : 'updateUrlRedirect', item }))
        },
        updateSuccessNotiUser: (item) => {
            dispatch(({ type : 'updateSuccessNotiUser', item }))
        },
        updateErrorNotiUser: (item) => {
            dispatch(({ type : 'updateErrorNotiUser', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(CreateTicketComponent);